module.exports = __webpack_public_path__ + "static/media/alexmavrishchev.5e71b65d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/alexmavrishchev.webp
// module id = 802
// module chunks = 0